import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as modalActions from '../redux/actions/modal-actions';
import ModalAddItem from './ModalAddItem';
import ModalElementCreation from './ModalElementCreation';
import ModalScan from './ModalScan';
import ModalConfirmation from './ModalConfirmation';
import ModalSendEmail from './ModalSendEmail';
import ModalGemini from './ModalGemini';
import ModalContact from './ModalContact';
import ModalConvert from './ModalConvert';
import ModalPDF from './ModalPDF';
import ModalPulseCreation from './ModalPulseCreation';
import ModalNewConnector from './ModalNewConnector';
import ModalStoreConnectors from './ModalStoreConnectors';
import ModalEvolutionSheet from './ModalEvolutionSheet';

const AllModalsRoot = () => {
  const dispatch = useDispatch();

  const globalModalState = useSelector((state) => state.modalReducer);

  return (
    <>
      {globalModalState.modalEmail.isOpen && (
        <ModalSendEmail
          {...globalModalState.modalEmail}
          modalCloseHandler={() =>
            dispatch(modalActions.modalEmail({ isOpen: false }))
          }
        />
      )}



      {globalModalState.modalConvert.isOpen && (
        <ModalConvert
          {...globalModalState.modalConvert}
          modalCloseHandler={() =>
            dispatch(modalActions.modalConvert({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalConnector.isOpen && (
        <ModalNewConnector
          {...globalModalState.modalConnector}
          modalCloseHandler={() =>
            dispatch(modalActions.modalConnector({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalStoreConnector.isOpen && (
        <ModalStoreConnectors
          {...globalModalState.modalStoreConnector}
          modalCloseHandler={() =>
            dispatch(modalActions.modalStoreConnector({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalEvolutionSheet.isOpen && (
        <ModalEvolutionSheet
          {...globalModalState.modalEvolutionSheet}
          modalCloseHandler={() =>
            dispatch(modalActions.modalEvolutionSheet({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalGemini.isOpen && (
        <ModalGemini
          {...globalModalState.modalGemini}
          modalCloseHandler={() =>
            dispatch(modalActions.modalGemini({ isOpen: false }))
          }
        />
      )}


      {globalModalState.modalConfirmation.isOpen && (
        <ModalConfirmation
          {...globalModalState.modalConfirmation}
          modalCloseHandler={() =>
            dispatch(modalActions.modalConfirmation({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalAddItem.isOpen && (
        <ModalAddItem
          {...globalModalState.modalAddItem}
          modalCloseHandler={() =>
            dispatch(modalActions.modalAddItem({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalElementCreation.isOpen && (
        <ModalElementCreation
          {...globalModalState.modalElementCreation}
          modalCloseHandler={() =>
            dispatch(modalActions.modalElementCreation({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalPulseCreation.isOpen && (
        <ModalPulseCreation
          {...globalModalState.modalPulseCreation}
          modalCloseHandler={() =>
            dispatch(modalActions.modalPulseCreation({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalScan.isOpen && (
        <ModalScan
          {...globalModalState.modalScan}
          modalCloseHandler={() =>
            dispatch(modalActions.modalScan({ isOpen: false }))
          }
        />
      )}

      {globalModalState.modalInvoice.isOpen && (
        <ModalPDF
          {...globalModalState.modalInvoice}
          modalCloseHandler={() =>
            dispatch(modalActions.modalInvoice({ isOpen: false }))
          }
        />
      )}
      {globalModalState.modalContact.isOpen && (
        <ModalContact
          {...globalModalState.modalContact}
          modalCloseHandler={() =>
            dispatch(modalActions.modalContact({ isOpen: false }))
          }
        />
      )}
    </>
  );
};

export default AllModalsRoot;
